import { Box, Button, Theme, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    textAlign: 'center',
    gap: theme.spacing(2)
  },
  header: {
    color: theme.palette.primary.main,
    fontSize: '2rem'
  }
}))

/**
 * BlinkPay return for the Goldie mobile app. The app's bank-consent redirect_uri points at this
 * page (BlinkPay only whitelists https hosts, not the goldie:// scheme), so the in-app browser
 * lands here after the bank. Hand straight back to the app: iOS/Android close the auth session
 * as soon as the page navigates to the app scheme, carrying BlinkPay's ?cid=… (and ?error=…)
 * through unchanged. The button is the fallback for browsers that block automatic scheme opens.
 */
export const appReturnUrl = (search: string): string =>
  `goldie://wallet/deposit/complete${search || ''}`

/** Only a phone can be handed to the app; a signed-out desktop visitor logs in instead. */
export const isMobileBrowser = (): boolean =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

export default function AppReturn(): JSX.Element {
  const { classes } = useStyles()
  const location = useLocation()
  const { search } = location
  const target = appReturnUrl(search)
  const mobile = isMobileBrowser()

  useEffect(() => {
    if (mobile) window.location.replace(target)
  }, [mobile, target])

  if (!mobile) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return (
    <Box className={classes.root}>
      <Typography variant='h4' className={classes.header}>
        Returning you to Goldie…
      </Typography>
      <Typography>
        Your bank has finished. If the app doesn&apos;t open by itself, tap
        below.
      </Typography>
      <Button variant='contained' href={target} data-testid='app-return-link'>
        Return to the Goldie app
      </Button>
    </Box>
  )
}
